
export default [

  {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'aptidao',
    label: 'Aptidão',
    valor: 'valor',
    tipo: 185,
    rules: ['required']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_alt',
    label: 'Trabalho em Altura',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_esp',
    label: 'Trabalho em Espaço Confinado',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_ele',
    label: 'Trabalho com Eletricidade',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_rad_ion',
    label: 'Trabalho com Radiação Ionizante',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
    type: 'select-tipo',
    field: 'te_ali',
    label: 'Manuseio de Alimentos',
    valor: 'valor',
    tipo: 189,
    rules: ['required']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'exames',
    label: 'Informe os Exames Alterados (caso existir algum)',
    clearable: true,
    multiple: true,
    option: {
      label: 'nome',
      value: 'id'
    },
    rules: ['']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    tipo: 53,
    rules: ['required']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'password',
    field: 'senha',
    label: 'Digite sua Senha',
    placeholder: 'Para continuar você deve inserir sua senha',
    rules: ['required']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    placeholder: 'Digite algo sobre a liberacao',
    rules: []
  },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/consulta/liberacao/_form/liberacao-aso.js